import React from 'react';
import moment from 'moment';
import Select from 'react-select';
import * as apiCaller from '../../../../helpers/apiCaller'
import serviceUrls from '../../../../constants/serviceUrls';
import uiHelpers from '../../../../helpers/uiHelpers';
import { Pen} from '../../../../components/tools/Icons';
import { InputText } from '../../../../components/tools/BootstrapControls';
import { LoadingPage } from '../../../../components/tools/Others';
import { convertSimCardActivationProcessStatus, convertSimCardAuditAction, convertSimCardStatus, nullToEmpty } from '../../../../helpers/converters';

const statusOptions = [
    {label:"Idle", value:'IDLE'},
    {label:"Activated", value:'ACTIVATED'},
    {label:"Archived", value:'ARCHIVED'}
];

class SimCardStatusEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected:statusOptions.filter(o=>o.value == props.status)[0],
            submitting:false
        }
    }

    onSelectChange= (option) => {
        this.setState({selected:option})
    }

    onSaveBtnClicked = async () => {       
        uiHelpers.showProgressOnTop('Saving...');
        this.setState({submitting:true});
        await apiCaller.post(serviceUrls.admin.updateSimCardStatus,{
            iccid:this.props.iccid,
            status:this.state.selected.value
        })
        .then((data)=>{
            this.props.updateCompleted(data.simCard,data.audits);
        }).finally(()=>{
            uiHelpers.hideProgressOnTop();
        })
    }

    render() {
        return <div class="card border border-primary mb-3">
            <div class="card-body">
                <div className='mb-3'>
                    <Select
                        placeholder=""
                        isDisabled={this.state.submitting}
                        className={null }
                        getOptionLabel={(o)=>o.label}
                        getOptionValue={(o)=>o.value}
                        options={statusOptions}
                        onChange={this.onSelectChange}
                        value={this.state.selected}
                    />
                </div>

                <button className='btn btn-primary me-2' onClick={this.onSaveBtnClicked} disabled={this.state.submitting}>Save</button>
                <button className='btn btn-secondary' onClick={this.props.onCancel} disabled={this.state.submitting}>Cancel</button>
            </div>
        </div>
    }
}

class SimCardLabelEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label:nullToEmpty(props.label),
            error:null,
            submitting:false
        }
    }

    onSaveBtnClicked = async () => {

        if(this.state.label && this.state.label.length > 200) {
            this.setState({error:'You have exceeded the maximum character limit (200) allowed for this field.'})
            return;
        } else {
            this.setState({error:null})
        }

        uiHelpers.showProgressOnTop('Saving...');
        this.setState({submitting:true});
        await apiCaller.post(serviceUrls.admin.updateSimCardLabel,{
            iccid:this.props.iccid,
            label:this.state.label
        })
        .then((data)=>{
            this.props.updateCompleted(data.simCard,data.audits);
        }).finally(()=>{
            uiHelpers.hideProgressOnTop();
        })
    }

    render() {
        return <div class="card border border-primary mb-3">
            <div class="card-body">
                <div className='mb-3'>
                    <InputText
                        value={this.state.label} 
                        disabled={this.state.submitting} 
                        error={this.state.error} 
                        onChange={(e)=>this.setState({label:e.target.value})} 
                    /> 
                </div>
                <button className='btn btn-primary me-2' onClick={this.onSaveBtnClicked} disabled={this.state.submitting}>Save</button>
                <button className='btn btn-secondary' onClick={this.props.onCancel} disabled={this.state.submitting}>Cancel</button>
            </div>
        </div>
    }
}


class SimCardAddNotes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notes:'',
            error:null,
            submitting:false
        }
    }

    onSaveBtnClicked = async () => {

        if(this.state.notes && this.state.notes.length > 4000) {
            this.setState({error:'You have exceeded the maximum character limit (4000) allowed for this field.'})
            return;
        } else if(!this.state.notes || this.state.notes.trim().length==0) {
            this.setState({error:'Please do not leave the note empty if you want to save.'})
            return;
        } else {
            this.setState({error:null})
        }

        uiHelpers.showProgressOnTop('Saving...');
        this.setState({submitting:true});
        await apiCaller.post(serviceUrls.admin.addSimCardNotes,{
            iccid:this.props.iccid,
            notes:this.state.notes
        })
        .then((data)=>{
            this.props.updateCompleted(data.simCard,data.audits);
        }).finally(()=>{
            uiHelpers.hideProgressOnTop();
        })
    }

    render() {
        return <div class="card border border-primary mb-3">
            <div class="card-body">
                <div className='mb-3'>
                    <textarea
                        class={`form-control ${(this.state.error) ? "is-invalid" : ""}`}
                        rows={5}
                        disabled={this.state.submitting}
                        onChange={(e)=>this.setState({notes:e.target.value})} 
                    ></textarea>
                    <div class="invalid-feedback">
                        {this.state.error}
                    </div>
                </div>
                <button className='btn btn-primary me-2' onClick={this.onSaveBtnClicked} disabled={this.state.submitting}>Save</button>
                <button className='btn btn-secondary' onClick={this.props.onCancel} disabled={this.state.submitting}>Cancel</button>
            </div>
        </div>
    }
}

class SimCardLidVendorEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            initialising:true,
            submitting:false,
            lidVendorSelect:null,
            lidVendorOptions:[]
        }
    }

    async componentDidMount() {

            await apiCaller.get(serviceUrls.admin.getAllLidVendors)
            .then((data)=>{
                const options = [
                    {label:'Unassigned', italic:false, value:'UNASSIGNED', lidVendor:null},
                    ...data.lidVendors.map(l=>{return {
                        label:l.name,
                        italic:false,
                        value:'LIDVENDOR',
                        lidVendor:l
                }})]
                let selected  = options[0];
                options.forEach(o => {
                    if(o.value=='LIDVENDOR' && o.lidVendor.id == this.props.lidVendorId) {
                        selected = o;
                    }
                });
                this.setState({lidVendorSelect:selected, lidVendorOptions:options})
            })
            .finally(()=>{
                this.setState({initialising:false});
            });
    }

    onLidVendorChanged =(o) =>{this.setState({lidVendorSelect : o});}

    onSaveBtnClicked = async () => {
        uiHelpers.showProgressOnTop('Saving...');
        this.setState({submitting:true});
        await apiCaller.post(serviceUrls.admin.udpateSimCardLidVendor,{
            iccid:this.props.iccid,
            lidVendorId:this.state.lidVendorSelect.value=='UNASSIGNED'?null:this.state.lidVendorSelect.lidVendor.id
        })
        .then((data)=>{
            this.props.updateCompleted(data.simCard,data.audits);
        }).finally(()=>{
            uiHelpers.hideProgressOnTop();
        })
    }

    render() {
        if(this.state.initialising) return <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>;
        return <div class="card border border-primary mb-3">
            <div class="card-body">
                <div className='mb-3'>
                    <Select
                        isDisabled={null}
                        getOptionLabel={o=>{
                            if(o.value == 'UNASSIGNED') {
                                return <i className='text-muted'>{o.label}</i>
                            } else if (o.value=='LIDVENDOR') {
                                return <span>{o.label} {o.lidVendor.active==false && <span className='text-danger fs-80'>(Inactive)</span>} </span>
                            }
                        }}
                        getOptionValue={o=>o}
                        options={this.state.lidVendorOptions}
                        onChange={this.onLidVendorChanged}
                        value={this.state.lidVendorSelect}
                    />
                </div>
                <button className='btn btn-primary me-2' onClick={this.onSaveBtnClicked} disabled={this.state.submitting}>Save</button>
                <button className='btn btn-secondary' onClick={this.props.onCancel} disabled={this.state.submitting}>Cancel</button>
            </div>
        </div>
    }
}





class SimCardDetailsAndEdit  extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            initialsing:true,
            disableEdit:false,
            simCard:null,
            audits:null,
            editingStatus : false,
            editingLabel: false,
            editingLidVendor:false,
            addingNotes:false
        }
    }

    async componentDidMount() {
        this.refresh();
    }

    updateCompleted = (simCard, audits, callback) => {
        this.setState({disableEdit:false, simCard:simCard, audits:audits,editingStatus:false,editingLabel:false,editingLidVendor:false, addingNotes:false}, callback)
    }

    refresh = async () => {
        uiHelpers.showProgressOnTop('Loading...');
        this.setState({disableEdit:true});
        await apiCaller.post(serviceUrls.admin.getSimCardDetails,{iccid : this.props.iccid})
        .then((data)=>{
            this.setState({disableEdit:false, initialsing:false, simCard:data.simCard,audits:data.audits, activationProcesses: data.activationProcesses});
        })
        .finally(()=>{
            uiHelpers.hideProgressOnTop();
        });
    }

    onEditStatusBtnClicked = () => {
        this.setState({disableEdit:true, editingStatus:true})
    }

    onEditStatusCancel = () => {
        this.setState({disableEdit:false, editingStatus:false})
    }

    onEditLabelBtnClicked = () => {
        this.setState({disableEdit:true, editingLabel:true})
    }

    onEditLabelCancel = () => {
        this.setState({disableEdit:false, editingLabel:false})
    }

    onEditLidVendorBtnClicked = () => {
        this.setState({disableEdit:true, editingLidVendor:true})
    }

    onEditLidVendorCancel = () => {
        this.setState({disableEdit:false, editingLidVendor:false})
    }

    onAddNotesBtnClick = () => {
        this.setState({disableEdit:true, addingNotes:true})
    }

    onAddNotesCancel = () => {
        this.setState({disableEdit:false, addingNotes:false})
    }

    render() {
        if(this.state.initialsing) return <LoadingPage/>
        return <>

        <div class="card mb-3">
            <div class="card-header  bg-primary text-white">
                <b>Sim Card Record</b>
            </div>
            <div className='card-body'>
                <div class="row mb-3 ">
                    <div class="col-md-3 py-2">ICCID</div>
                    <div className="col-md-9">
                        <div class="card bg-light mb-3">
                            <div class="card-body p-2 text-wrap">
                                {this.state.simCard.iccid}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-3 ">
                    <div class="col-md-3 py-2">Status</div>
                    <div className="col-md-9">
                        {this.state.editingStatus ? <SimCardStatusEdit status={this.state.simCard.status} onCancel={this.onEditStatusCancel} updateCompleted={this.updateCompleted} iccid={this.state.simCard.iccid}/> 
                        : 
                        <div class="card bg-light mb-3">
                            <div class="card-body p-2 text-wrap">
                                <button className='btn btn-outline-primary btn-sm me-3' onClick={this.onEditStatusBtnClicked} disabled={this.state.disableEdit}><Pen/></button>
                                {convertSimCardStatus(this.state.simCard.status)}
                            </div>
                        </div>}
                    </div>
                    
                </div>
                <div class="row mb-3 ">
                    <div class="col-md-3 py-2">LID Vendor</div>
                    <div className="col-md-9">

                        {this.state.editingLidVendor ? <SimCardLidVendorEdit lidVendorId={this.state.simCard.lidVendor?this.state.simCard.lidVendor.id:null} onCancel={this.onEditLidVendorCancel} updateCompleted={this.updateCompleted} iccid={this.state.simCard.iccid} /> 
                        : 
                        <div class="card bg-light mb-3">
                            <div class="card-body p-2 text-wrap">
                                <button className='btn btn-outline-primary btn-sm me-3' onClick={this.onEditLidVendorBtnClicked} disabled={this.state.disableEdit}><Pen/></button>
                                {!this.state.simCard.lidVendor && <i className='text-muted'>Unassigned</i>}
                                {this.state.simCard.lidVendor && this.state.simCard.lidVendor.name}
                            </div>
                        </div>}
                    </div>
                </div>
                <div class="row mb-3 ">
                    <div class="col-md-3 py-2">Created Date</div>
                    <div className="col-md-9">
                        <div class="card bg-light mb-3">
                            <div class="card-body p-2 text-wrap">
                                {moment((new Date(this.state.simCard.createdDate))).format('DD/MM/YYYY h:mma')}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-3 ">
                    <div class="col-md-3 py-2">Created By</div>
                    <div className="col-md-9">
                        <div class="card bg-light mb-3">
                            <div class="card-body p-2 text-wrap">
                                {this.state.simCard.createdBy.firstname} {this.state.simCard.createdBy.lastname}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3 ">
                    <div class="col-md-3 py-2">Label</div>
                    <div className="col-md-9">
                        {this.state.editingLabel ? <SimCardLabelEdit label={this.state.simCard.label} onCancel={this.onEditLabelCancel} updateCompleted={this.updateCompleted} iccid={this.state.simCard.iccid} /> 
                        : 
                        <div class="card bg-light mb-3">
                            <div class="card-body p-2 text-wrap">
                                <button className='btn btn-outline-primary btn-sm me-3' onClick={this.onEditLabelBtnClicked} disabled={this.state.disableEdit}><Pen/></button>
                                {this.state.simCard.label}
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div>

        {this.state.activationProcesses && <div class="card mb-3">
            <div class="card-header  bg-primary text-white">
                <b>Sim Activation Processes</b>
            </div>
            <div className='card-body'>
                <div class="table-responsive-xxl">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col" style={{width:"220px"}}>ICCID</th>
                                <th scope="col" style={{width:"130px"}}>Status</th>
                                <th scope="col" style={{width:"200px"}}>Started Date</th>
                                <th scope="col" style={{width:"200px"}}>Completed Date</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.activationProcesses.length==0 && <tr>
                                <td colSpan={10} className='table-light text-center text-muted'>
                                    <i>No activation process record</i>
                                </td>
                            </tr>}
                            {this.state.activationProcesses.map(h=>{
    
                                return <tr>
                                    <td>{h.iccid}</td>
                                    <td>{convertSimCardActivationProcessStatus(h.status)}</td>
                                    <td>{moment((new Date(h.createdDate))).format('DD/MM/YYYY h:mm:ss a')}</td>
                                    <td>{h.completionDate && moment((new Date(h.completionDate))).format('DD/MM/YYYY h:mm:ss a')}</td>
                                    <td className='text-end'>
                                        <a className='btn btn-sm btn-primary' href={`/#/sim-activation-process/details/${h.id}`} target='_blank'>Open</a>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>}

        <div class="card mb-3">
            <div class="card-header  bg-primary text-white">
                <b>Sim Card Audits</b>
            </div>
            <div className='card-body'>

                {this.state.addingNotes ? <SimCardAddNotes onCancel={this.onAddNotesCancel} updateCompleted={this.updateCompleted} iccid={this.state.simCard.iccid} />
                : 
                <div class="mb-3">
                    <button className='btn btn-primary me-3' onClick={this.onAddNotesBtnClick} disabled={this.state.disableEdit}>Add Notes</button>
                </div>}

                
                
                <div class="table-responsive-xxl">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col" style={{width:"200px"}}>Date &amp; Time</th>
                                <th scope="col" style={{width:"200px"}}>Action</th>
                                <th scope="col" style={{width:"180px"}}>User</th>
                                <th scope="col">Comments / Other Info</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.audits.length==0 && <tr>
                                <td colSpan={10} className='table-light text-center text-muted'>
                                    <i>No audit record</i>
                                </td>
                            </tr>}
                            {this.state.audits.map(a=><tr>
                                <td>{moment((new Date(a.auditDate))).format('DD/MM/YYYY h:mm:ss a')}</td>
                                <td>{convertSimCardAuditAction(a.auditAction)}</td>
                                <td>{a.auditUser && <>{a.auditUser.firstname} {a.auditUser.lastname}</>}</td>
                                <td>
                                    {a.comments && <pre style={{"white-space": "pre-wrap"}}>
                                        {a.comments}
                                    </pre>}
                                    {a.auditAction=='CHANGE_STATUS' && <>
                                        Changed from <span className='text-primary'>{convertSimCardStatus(a.originalStatus)}</span> to <strong className='text-primary'>{convertSimCardStatus(a.newStatus)}</strong>
                                    </>}

                                    {a.auditAction=='UPDATE_LID_VENDOR' && <>
                                        Changed from {a.originalLidVendor ? <span className='text-primary'>{a.originalLidVendor.name}</span> : <i className='text-muted'>Unassigned</i>} to {a.newLidVendor ? <strong className='text-primary'>{a.newLidVendor.name}</strong> : <i className='text-muted'><strong>Unassigned</strong></i>}
                                    </>}
                                </td>

                            </tr>)}
                            
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
        </>
    }
}

export default SimCardDetailsAndEdit;


